// ----------------------------------------------------------------------
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, import/no-default-export
export default function Card(theme) {
    return {
        "MuiCard": {
            "styleOverrides": {
                "root": {
                    "borderRadius": window.Number(theme.shape.borderRadius) * 2,
                    "position": "relative",
                    "zIndex": 0,
                },
            },
        },
        "MuiCardContent": {
            "styleOverrides": {
                "root": {
                    "padding": theme.spacing(3),
                },
            },
        },
        "MuiCardHeader": {
            "defaultProps": {
                "subheaderTypographyProps": { "variant": "body2" },
                "titleTypographyProps": { "variant": "h6" },
            },
            "styleOverrides": {
                "root": {
                    "padding": theme.spacing(3, 3, 0),
                },
            },
        },
    };
}
